module.exports = __webpack_public_path__ + "static/img/ket-renewal-thumb.60e25e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/ket-renewal-thumb.jpg
// module id = IGVp
// module chunks = 0